import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAreaTypeResponse } from "@miplatform/types";

export const useAreaTypesViewModel = () => {
  const stateManager = useComponentState();

  const [selectedAreaType, setSelectedAreaType] =
    useState<IAreaTypeResponse | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleDeleteAreaType = (area: IAreaTypeResponse) => {
    stateManager.run(async () => {
      const response = await homeService.areaTypes.delete({
        id: area.id,
        modifiedOn: area.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${area.name} was deleted successfully.`,
          },
          failure: {
            text: `Failed to delete ${area.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
        setSelectedAreaType(null);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    selectedAreaType,
    showDeleteModal,
    refresh,
    setRefresh,
    setSelectedAreaType,
    setShowDeleteModal,
    handleDeleteAreaType,
  };
};
